const stackedCardLoadMore = document.querySelector(
	'.block-card-stacked.load-more'
);

const editorDiv = document.querySelector('.editor-styles-wrapper');

const stackedLoad = () => {
	// load more.
	if (stackedCardLoadMore && !editorDiv) {
		let currentCount = 6;

		const moreTripBtn = document.querySelector(
			'.block-card-stacked__btn-con .c-btn'
		);

		const cardImages = document.querySelectorAll(
			'.load-more .block-card-image'
		);

		moreTripBtn.addEventListener('click', function () {
			currentCount += 4;
			const currentSelections = document.querySelectorAll(
				`.load-more .block-card-image:nth-child(-n+${currentCount})`
			);
			// console.log(currentSelections);
			currentSelections.forEach((element) => {
				element.classList.add('active');
			});

			if (currentCount >= cardImages.length) {
				document
					.querySelector('.block-card-stacked__btn-con')
					.classList.add('remove');
			}
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		stackedLoad();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};

export default controller;
